import React, { useState } from 'react';
import OrderProcess from "../components/OrderProcess";
import {ReactComponent as SearchIcon} from '../components/svgs/searchicon.svg';
import {ReactComponent as AddIcon} from '../components/svgs/addicon.svg';
import {ReactComponent as PadlockIcon} from '../components/svgs/padlockIcon.svg';
import {ReactComponent as OnToggleIcon} from '../components/svgs/onToggle.svg';
import {ReactComponent as OffToggleIcon} from '../components/svgs/offToggle.svg';
import {ReactComponent as InputCircleIcon} from '../components/svgs/inputCircle.svg';
import {ReactComponent as InputCircleFilledIcon} from '../components/svgs/inputCircleFilledIcon.svg';
import {ReactComponent as AddCardIcon} from '../components/svgs/addCardIcon.svg';
import {ReactComponent as LinkIcon} from '../components/svgs/linkIcon.svg';
import InputDropdown from "../components/InputDropdown";
import Button from "../components/Button";
import DropdownDatePicker from "../components/DropdownDatePicker";
import DropdownTimePicker from "../components/DropdownTimePicker";
import CreateCustomerForm from '../components/CreateCustomerForm';
// import Success from '../components/SuccessPage';

// services data
const services = [
    { label: 'Rugs', link: '#' },
    { label: 'Small bag', link: '#' },
    { label: 'Large bag', link: '#' },
    { label: 'Lab coat', link: '#' },
    { label: 'Throw pillows', link: '#' },
    { label: 'Mattress cover', link: '#' },
    { label: 'Light mattress cover', link: '#' },
    { label: 'Down comforter (Twin & Full)', link: '#' },
    { label: 'Down comforter (Queen & King)', link: '#' },
    { label: 'Queen & King  (Comforter, Quilt, Bedspread)', link: '#' },
    { label: 'Wash N Fold (min. 10 lbs)', link: '#' },
    { label: 'Same Day Service (min. 10 lbs)', link: '#' },
  ];


  const handleSelect = (option) => {
    console.log('Selected option:', option);
  }; 


const CreateOrderScreen = ({ isOpen, onClose }) => {
    const [currentPage, setCurrentPage] = useState(1); // Track current page

  const handleNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const handleCancel = () => {
    onClose();
  };

  // Logic to determine when the success condition is met
  
//   const [isSuccess, setIsSuccess] = useState(false);

  return (
    <>
        <div className={`side-page ${isOpen ? 'open' : ''}`}>
            <section className="create-order-header-section no-background">
                <div className="content">
                    <h2 className="create-order-page-title mt-10">Create Order</h2>
                    <p className="create-order-page-subtitle">Fill out these details to proceed</p>
                </div>
               
            </section>
            <div className="modal-body">
          {/* Render different pages based on currentPage */}
          {currentPage === 1 && (
            <CreateOrder onNextPage={handleNextPage}  onCancel={handleCancel} />
          )}
          {currentPage === 2 && (
            <Payment onNextPage={handleNextPage} onPrevPage={handlePrevPage} onCancel={handleCancel} />
          )}
          {currentPage === 3 && (
            <CompleteOrder onNextPage={handleNextPage} onPrevPage={handlePrevPage} onCancel={handleCancel} />
          )}
          {/* {successCondition && (
            <Success onPrevPage={handlePrevPage} onCancel={handleCancel} />
          )} */}

            
          
        </div>
            
        </div>
    </>
  );
};


// Separate components for each page
const CreateOrder = ({ onNextPage, onCancel }) => {
  
      const [showNewCustomerForm, setShowNewCustomerForm] = useState(false);
      const [quantity, setQuantity] = useState(0);
      const [size, setSize] = useState(0);
      

  // Function to handle incrementing the quantity and size
  const increment = (e) => {
    e.preventDefault()
    // setQuantity(prevQuantity => prevQuantity + 1);
    setQuantity((prevQuantity) => parseFloat((prevQuantity + 0.01).toFixed(2)));
   
  };

  const incrementSize = (e) => {
    e.preventDefault()
    // setSize(prevSize => prevSize + 1);
    setSize((prevSize) => parseFloat((prevSize + 0.01).toFixed(2)));
  }


  // Function to handle decrementing the quantity and size
  const decrement = (e) => {
    e.preventDefault()
    if (quantity > 0) {
      // setQuantity(prevQuantity => prevQuantity - 1);
      setSize((prevQuantity) => parseFloat((prevQuantity - 0.01).toFixed(2)));
    }
   
  };

  const decrementSize = (e) =>{
    e.preventDefault()
    if (size > 0) {
        // setSize(prevSize => prevSize - 1);
        setSize((prevSize) => parseFloat((prevSize - 0.01).toFixed(2)));
    }
  }

  const handleSizeChange = (e) => {
    const value = parseFloat(e.target.value);
    if (value === '') {
      setSize(0);
    } else {
      const numericValue = parseFloat(value);
      setSize(isNaN(numericValue) ? 0 : parseFloat(numericValue.toFixed(2)));
    }
  };

  const handleQuantityChange = (e) => {
    const value = parseFloat(e.target.value);
    if (value === '') {
      setQuantity(0);
    } else {
      const numericValue = parseFloat(value);
      setQuantity(isNaN(numericValue) ? 0 : parseFloat(numericValue.toFixed(2)));
    }
  };

  const handleNewCustomerClick = () => {
    setShowNewCustomerForm(true);
  };

  const handleCancelNewCustomerForm = () => {
    setShowNewCustomerForm(false);
  };

  const handleNewCustomerFormSubmit = () => {
    // Logic to handle form submission
    // For example, you can send a request to add a new customer
    setShowNewCustomerForm(false); // Close the form after submission
  };


    return (
        <div>
            <section className="order-process-section">
                <OrderProcess orderDetails={true} payment={false} completeOrder={false}/>
            </section>
            <form action="" className="create-order-form">
        
                    <section className="create-order-form">
                        <section className="flex flex-col gap-4">
                            <label htmlFor="" className="flex flex-col search-input">
                                Who is this order for?
                            
                                <SearchIcon className='search-icon'/>
                                <input type="text" placeholder="Search customers" className="mt-2"/>
                            </label>

                            {/* customer form */}
                            <div className="flex gap-4">
                                <AddIcon onClick={handleNewCustomerClick} />
                                <p className="add-new-customer-btn" onClick={handleNewCustomerClick}>New customer</p>
                            </div>
                            <CreateCustomerForm
                                isOpen={showNewCustomerForm}
                                onClose={handleCancelNewCustomerForm}
                                onSubmit={handleNewCustomerFormSubmit}
                            />
                            {/* customer form */}
                        </section>
                        <section className="flex flex-col gap-10 mt-5">
                            <section className="flex gap-10 order-details">
                                <label htmlFor="" className="flex flex-col">
                                    Number of bags
                                    <input type="text" className="mt-2" placeholder="0"/>
                                </label>
                                <div className=" custom-number-input">
                                    <button onClick={decrementSize} className='decrement-btn decrementsize-btn'>⌃</button>
                                    <label htmlFor="" className='quantity-input'>Size
                                    <input
                                        type="number"
                                        value={size === 0 ? '' : size}
                                        placeholder='0'
                                        onChange={handleSizeChange}
                                        min="1"
                                        className='mt-2'
                                        step="0.01"
                                    />
                                    </label>
                                    <button onClick={incrementSize} className='increment-btn'>⌃</button>
                                </div>
                            </section>
                            <section className="flex gap-9">
                                <label htmlFor="" className="flex flex-col ">
                                    Service
                                    <InputDropdown options={services} onSelect={handleSelect} inputClass={'service-input mt-2'}/>
                                </label>
                                <label htmlFor="" className="flex flex-col price-per-unit">
                                    Price per unit
                                    <PadlockIcon className='padlock-icon'/>
                                    <input type="number" placeholder="$40" disabled className="mt-2"/>
                                </label>
                                <section>
                                    <div className=" custom-number-input ">
                                        <button onClick={decrement} className='decrement-btn'>⌃</button>
                                        <label htmlFor="" className='quantity-input'>Quantity
                                        <input
                                            type="number"
                                            value={quantity === 0 ? '' : quantity}
                                            onChange={handleQuantityChange}
                                            min="1"
                                            className='mt-2'
                                            step="0.01"
                                            placeholder='0'
                                        />
                                        </label>
                                        <button onClick={increment} className='increment-btn'>⌃</button>
                                    </div>
                                </section>
                                
                                <Button style={{'height': '60px', 'marginTop': '22px'}}>Add</Button>
                            </section>
                        </section>
                        <section className="flex gap-10 mt-10">
                            <section>
                                <DropdownDatePicker/>
                            </section>
                            <section>
                                <DropdownTimePicker/>
                            </section>
                        
                        </section>
                        <label htmlFor="" className="mt-5 mb-72">
                                Notes
                                <textarea name="" id="" cols="30" rows="10" className="order-notes mt-2" placeholder="Enter a special request"></textarea>
                        </label>
                
                        <section className="mt-4 create-order-cta-section">
                            <div className="create-order-divider"></div>
                            <section className="flex mt-20 create-order-cta">
                                <Button onClick={onCancel} style={{'background': 'none', 'color': '#434C5A', 'fontWeight': '400'}} >Cancel Order</Button>
                                <Button onClick={onNextPage}>Next</Button>
                                
                            </section>
                        </section>

                    </section>
                
            </form>
            
        </div>
    );
  };
  
  const Payment = ({ onNextPage, onPrevPage, onCancel }) => {
    const [showPaymentPreference, setShowPaymentPreference] = useState(false);
    const [selectedButton, setSelectedButton] = useState(null);

    const togglePaymentPreference = () => {
        setShowPaymentPreference(!showPaymentPreference);
    };

    const handleButtonClick = (buttonIndex) => {
      setSelectedButton(buttonIndex === selectedButton ? null : buttonIndex);
    };

    const renderContent = () => {
        if (selectedButton === null) {
          return null;
        } else if (selectedButton === 0 || selectedButton === 1) {
          return (
            <>
            <section>
                
            </section>
            <div className='mt-10 flex flex-col'>
              <p className='payment-preference-text'>Select payment method </p>
              <select disabled={selectedButton === 1} className='mt-6 choose-payment-dropdown'>
                <option value="option1">Credit Card</option>
                <option value="option2">Check</option>
                <option value="option3">Apple Pay</option>
                <option value="option3">Cash</option>
                <option value="option3">Google Pay</option>
                <option value="option3">Laundry Works</option>
              </select>
              
            </div>
            <section className='mt-48 save-cards-section'>
                <div className='saved-cards-flag'>
                    <p className='saved-cards-flag-text'>No saved credit cards</p>
                </div>
                <div className='flex mt-10 gap-10'>
                    <div className='flex gap-4'>
                        <AddCardIcon/>
                        <p className='add-card-section-text'>Add card with Terminal</p>
                    </div>
                    <div className='flex gap-4'>
                        <LinkIcon/>
                        <p className='add-card-section-text'>Add card with Link</p>
                    </div>
                </div>
            </section>
          </>
          );
        } else {
          return <p className='payment-preference-text-3'>An invoice will be automatically generated and sent for this order upon completion</p>;
        }
      };

      const renderIcon = (buttonIndex) => {
        if (selectedButton === buttonIndex) {
          return (
            <InputCircleFilledIcon/>
          );
        } else {
          return (
            <InputCircleIcon/>
          );
        }
      };
  

    return (
      <div>
        <section className="order-process-section payment-process">
            <OrderProcess orderDetails={false} payment={true} completeOrder={false}/>
        </section>
        <section className='payment-form flex gap-4'>
            <div className='flex flex-col'>
                <Button onClick={togglePaymentPreference} style={{'background': 'none', 'padding': '0', 'marginTop': '10px', 'width': '0', 'height': '0'}}>
                    {showPaymentPreference ? (
                    <OffToggleIcon/>
                    ) : (
                    <OnToggleIcon />
                    )}
                </Button>
                <section className='payment-preference-section'>
                    {showPaymentPreference && (
                        <section className='' >
                            <p className='payment-preference-text'>Choose payment preference</p>

                                <div className='flex gap-10'>
                                    <div className='flex gap-11'>
                                        
                                        <Button onClick={() => handleButtonClick(0)} className='' style={{'background': 'none', 'padding': '0', 'marginTop': '10px', 'width': '0', 'height': '0'}}>{renderIcon(0)}</Button>
                                        
                                        <p className='payment-preference-text-2'>Pay now</p>
                                    </div>
                                    <div className='flex gap-11'>
                                       
                                        <Button onClick={() => handleButtonClick(1)} className='' style={{'background': 'none', 'padding': '0', 'marginTop': '10px', 'width': '0', 'height': '0'}}>{renderIcon(1)}</Button>
                                    
                                        <p className='payment-preference-text-2'>Pay on completion</p>
                                    </div>
                                    <div className='flex gap-11'>
                                        <Button onClick={() => handleButtonClick(2)} className='' style={{'background': 'none', 'padding': '0', 'marginTop': '10px', 'width': '0', 'height': '0'}}>{renderIcon(2)}</Button>
                                        <p className='payment-preference-text-2'>Invoice on completion</p>
                                    </div>
                                    <div className='flex gap-11'>
                                        <Button onClick={() => handleButtonClick(3)} className='' style={{'background': 'none', 'padding': '0', 'marginTop': '10px', 'width': '0', 'height': '0'}}>{renderIcon(3)}</Button>
                                        <p className='payment-preference-text-2'>Pay at pickup</p>
                                    </div>
                                </div>
                                <div className='flex'>
                                    {renderContent()}
                                </div>

                        </section>
                    )}
                </section>
                
            </div>
            <section className='flex flex-col invoice-bill-section' style={{'height': '80px'}}>
                <p className='bill-on-invoice-text'>Bill on next invoice</p>
                <p className='bill-on-invoice-subtext'>Order will be added to next invoice payable on <span>January 31st, 2024</span></p>
            </section>
        </section>
        {/* Form elements for Page 2 */}
        <section className="create-order-cta-section create-order-cta-section-pg2">
            <div className="create-order-divider"></div>
            <section className="flex mt-10 create-order-cta">
               
                <Button onClick={onCancel} style={{'background': 'none', 'color': '#434C5A', 'fontWeight': '400'}}>Cancel Order</Button>
                <div className='mr-10 next-back-btn-section'>
                    <Button style={{'background': '#F1F9FD', 'color': '#529FBE', 'fontWeight': '400', 'marginRight': '20px'}} onClick={onPrevPage}>Back</Button>
                    <Button onClick={onNextPage}>Next</Button>
                    </div>
            </section>
        </section>
        
      </div>
    );
  };
  
  const CompleteOrder = ({ onNextPage, onPrevPage, onCancel}) => {
    return (
      <>
        <section className="order-process-section complete-order-page">
            <OrderProcess orderDetails={false} payment={false} completeOrder={true}/>
        </section>
        <section className='order-summary-section flex flex-col gap-8'>
            <div className='flex gap-52'>
                <div className='flex flex-col gap-4'>
                    <p className='order-summary-title'>Customer</p>
                    <div className='flex gap-4'>
                        <div className='company-initials mt-4'>
                            <p className='company-initials-text'>GI</p>
                        </div>
                        <div className='flex flex-col'>
                            <p className='company-name'>Geller Industries</p>
                            <p className='company-rep'>Monica Geller</p>
                        </div>
                    </div>
                </div>
                <div className='flex flex-col gap-4'>
                    <p className='order-summary-title'>No of bags</p>
                    <p className='no-of-bags'>3</p>
                </div>
                <div className='flex flex-col gap-4'>
                    <p className='order-summary-title'>SubTotal</p>
                    <p className='total-price'>$419.00</p>
                    
                </div>
            </div>
            <div className='order-summary-divider'></div>
            <section className='flex gap-64'>
                <div className='flex flex-col gap-4'>
                    <p className='order-summary-title'>Size in pounds</p>
                    <p className='order-summary-subtitle'>23 lbs.</p>
                </div>
                <div className='flex flex-col gap-4'>
                    <p className='order-summary-title'>Pickup date</p>
                    <p className='order-summary-subtitle'>12/11/23</p>
                </div>
                <div className='flex flex-col gap-4'>
                    <p className='order-summary-title'>Pickup time</p>
                    <p className='order-summary-subtitle'>11:00am</p>
                </div>
            </section>
            <section className='flex flex-col gap-4'>
                <div className='flex flex-col gap-6'>
                    <p className='order-summary-title'>Requested service(s)</p>
                    <p className='order-summary-subtitle'>Deep soak, drying, ironing, steam iron.</p>
                </div>
            </section>
            <section className='flex flex-col'>
                <div className='flex flex-col gap-4'>
                    <p className='order-summary-title'>Notes</p>
                    <p className='client-notes'>Client is very straightforward about his products, he loves clean efficient installation and stress-free regular maintenance.</p>
                </div>
            </section>
            <div className='order-summary-divider'></div>
            <section>
                <div className='flex flex-col gap-4'>
                    <p className='order-summary-title'>Payment preference</p>
                    <p className='order-summary-subtitle'>Bill on next invoice</p>
                </div>
            </section>
        </section>
        <section className="mt-4 create-order-cta-section">
            <div className="create-order-divider"></div>
            <section className="flex mt-10 create-order-cta">
                <Button onClick={onCancel} style={{'background': 'none', 'color': '#434C5A', 'fontWeight': '400'}}>Cancel Order</Button>
                <div className='next-back-btn-section-order-summary'>
                    <Button style={{'background': '#F1F9FD', 'color': '#529FBE', 'fontWeight': '400'}} onClick={onPrevPage}>Back</Button>
                    <Button onClick={onCancel} style={{'marginLeft': '30px'}}>Complete</Button>
                    </div>
            </section>
        </section>
      </>
    );
  };
  
//   const Success = ({ onNextPage, onPrevPage }) => {
//     return (
//       <div>
//         <h3>Page 4</h3>
       
//         <section className="mt-4 create-order-cta-section">
//             <div className="create-order-divider"></div>
//             <section className="flex mt-20 create-order-cta">
//                 <Button style={{'background': 'none', 'color': '#434C5A', 'fontWeight': '400'}} onClick={onPrevPage}>Back</Button>
//                 <Button onClick={onNextPage}>Next</Button>
                
//             </section>
//         </section>
//       </div>
//     );
//   };




export default CreateOrderScreen;
